import React from "react";
import { useAppContext } from "../../helpers/account-context";
import { ResultLine, DetailLine, InfowinLine } from "./Mixin";

const DirectionTag = (props) => {
  const { item } = props;
  const destination = [item.properties.lat, item.properties.lng].join(',')
  // item.properties.full_address
  const directionUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
  const { getLocale } = useAppContext()
  return (
   
        <a className="cbmap-link" href={`${directionUrl}`} target={`_blank`}>
          {getLocale('get_directions')}
        </a>      
  );
};

export const DirectionResult = (props) => {
  return (
    <ResultLine className="cbmap-item_directions">
      <DirectionTag {...props} />
    </ResultLine>
  );
};

export const DirectionDetail = (props) => {
  return (
    <DetailLine className="cbmap-details_directions">
      <DirectionTag {...props} />
    </DetailLine>
  );
};

export const DirectionInfowin = (props) => {
  return (
    <InfowinLine className="cbmap-infowin_directions">
      <DirectionTag {...props} />
    </InfowinLine>
  );
};
